import { useEffect } from 'react'
import * as d3 from "d3";
import { UsageModel } from '../../models/plan-metrics.model';

interface IProps {
    Data: UsageModel;
    Title: string;
    IsMobileDevice: boolean;
}


const ProgressBar = (props: IProps) => {

    const loadProgress = () => {

        d3.select(`#${props.Title.toLowerCase().replaceAll(" ", "").replaceAll("-", "")}`).selectChildren().remove();

        var svg = d3.select(`#${props.Title.toLowerCase().replaceAll(" ", "").replaceAll("-", "")}`)
            .append('svg')
            .attr('height', 20)
            .attr('width', "100%")

        var gradient = svg.append('defs')
            .append("linearGradient")
            .attr("id", `gradient-${props.Title.toLowerCase().replaceAll(" ", "").replaceAll("-", "")}`)
            .attr("x1", "0%")
            .attr("y1", "50%")
            .attr("x2", "100%")
            .attr("y2", "50%");


        if (props.Data.GetPercentile() < 60) {
            gradient.append("stop")
                .attr("offset", "0%")
                .attr("stop-color", "#04EC04")
                .attr("stop-opacity", 1);
            gradient.append("stop")
                .attr("offset", "100%")
                .attr("stop-color", "#35C735")
                .attr("stop-opacity", 1);
        } else if (props.Data.GetPercentile() >= 60 && props.Data.GetPercentile() < 90) {
            gradient.append("stop")
                .attr("offset", "0%")
                .attr("stop-color", "orange")
                .attr("stop-opacity", 1);
            gradient.append("stop")
                .attr("offset", "100%")
                .attr("stop-color", "#BB2C27")
                .attr("stop-opacity", 1);
        } else if (props.Data.GetPercentile() >= 90) {
            gradient.append("stop")
                .attr("offset", "0%")
                .attr("stop-color", "#BB2C27")
                .attr("stop-opacity", 1);
            gradient.append("stop")
                .attr("offset", "100%")
                .attr("stop-color", "#BB2C27")
                .attr("stop-opacity", 1);
        }

        svg.append('rect')
            .attr('class', 'bg-rect br-2')
            .attr('rx', 10)
            .attr('ry', 10)
            .attr('fill', 'white')
            .attr('height', 15)
            .attr('width', "100%")
            .attr('x', 0);

        var progress = svg.append('rect')
            .attr('class', 'progress-rect ')
            .attr('fill', `url(#gradient-${props.Title.toLowerCase().replaceAll(" ", "").replaceAll("-", "")})`)
            .attr('height', 15)
            .attr('width', 0)
            .attr('rx', 10)
            .attr('ry', 10)
            .attr('x', 0)


        progress.transition()
            .duration(1000)
            .attr('width', `${props.Data.GetPercentile()}%`)

        svg.append('text')
            .attr('fill', props.Data.GetPercentile() > 30 ? 'white' : 'black')
            .attr('x', `${Math.abs(props.Data.GetPercentile() - (props.IsMobileDevice ? 16 : 12))
                }% `)
            .attr('y', 10)
            .attr("dx", 0)
            .attr("dy", 1)
            .text(calculatePercentage(props.Data.GetPercentile()).toString())
    }
    const calculatePercentage = (val: number) => {
        if (val > 20) { return val + "%" }
        else { return "" }

    }

    useEffect(() => {
        loadProgress()
    }, [props.Data])
    return (
        <div id={props.Title.toLowerCase().replaceAll(" ", "").replaceAll("-", "")} className="br-2 progress"></div>

    );

}
export default ProgressBar;